import { TranslationKey } from '../../../translations/TranslationKey';
import TranslatedMessage from '../../translations/TranslatedMessage';
import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';

type LanguageListProps = {
  languageRegions: string[];
};

const useStyles = makeStyles(theme => (createStyles({
  language: {
    marginRight: '10px',
  }
})));

const LanguageList: React.FunctionComponent<LanguageListProps> = ({ languageRegions }) => {
  const cssClasses = useStyles({});;
  const languages = languageRegions.map(languageRegion =>
    <Chip component="span" key={languageRegion} className={cssClasses.language} label={<TranslatedMessage id={`common.language.${languageRegion.toLowerCase()}` as TranslationKey} />} />);

  return (<React.Fragment>
    {languages}
  </React.Fragment>);
}

export default LanguageList;
